import { ExternalLink, Info } from 'lucide-react';
import { Card } from '../ui/Card';

export function FinancialAidCard() {
  return (
    <Card className="p-4 bg-green-50 border-green-200">
      <div className="flex items-start gap-3">
        <Info className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="font-semibold text-green-900 mb-2">
            Aides financières disponibles
          </h3>
          <p className="text-sm text-green-800 mb-3">
            De nombreuses aides peuvent réduire significativement votre reste à charge:
          </p>
          <div className="space-y-2 mb-4">
            <div className="text-sm">
              <div className="font-semibold text-green-900">MaPrimeRénov</div>
              <div className="text-green-700">
                Jusqu'à 90% du coût des travaux selon vos revenus (plafonds par poste)
              </div>
            </div>
            <div className="text-sm">
              <div className="font-semibold text-green-900">Certificats d'Économies d'Énergie (CEE)</div>
              <div className="text-green-700">
                Prime versée par les fournisseurs d'énergie (500€ à 3000€ selon travaux)
              </div>
            </div>
            <div className="text-sm">
              <div className="font-semibold text-green-900">Éco-prêt à taux zéro (éco-PTZ)</div>
              <div className="text-green-700">
                Prêt sans intérêts jusqu'à 50 000€ pour financer vos travaux
              </div>
            </div>
            <div className="text-sm">
              <div className="font-semibold text-green-900">TVA réduite à 5,5%</div>
              <div className="text-green-700">
                Sur tous les travaux d'amélioration de la performance énergétique
              </div>
            </div>
          </div>
          <div className="flex gap-3">
            <a
              href="https://france-renov.gouv.fr/aides/simulation"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors text-sm font-medium"
            >
              Simuler mes aides
              <ExternalLink className="w-4 h-4" />
            </a>
            <a
              href="https://www.maprimerenov.gouv.fr/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-green-600 text-green-700 rounded-lg hover:bg-green-50 transition-colors text-sm font-medium"
            >
              En savoir plus
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </Card>
  );
}
